// extracted by mini-css-extract-plugin
export default {"answersList":"C_bX"};